<!--
  @author Simeon Artamonov <simeon@cross-works.co.uk>
  @company Cross Works Ltd
-->
<template>
  <svg 
    width="20" 
    height="20" 
    viewBox="0 0 20 20" 
    fill="none" 
    xmlns="http://www.w3.org/2000/svg"
    class="facebook-icon"
  >
    <path 
      d="M19.2 0H0.8C0.3575 0 0 0.3575 0 0.8V19.2C0 19.6425 0.3575 20 0.8 20H19.2C19.6425 20 20 19.6425 20 19.2V0.8C20 0.3575 19.6425 0 19.2 0ZM16.89 5.8375H15.2925C14.04 5.8375 13.7975 6.4325 13.7975 7.3075V9.235H16.7875L16.3975 12.2525H13.7975V20H10.68V12.255H8.0725V9.235H10.68V7.01C10.68 4.4275 12.2575 3.02 14.5625 3.02C15.6675 3.02 16.615 3.1025 16.8925 3.14V5.8375H16.89Z" 
      fill="var(--theme-link)"
    />
  </svg>
</template>

<style lang="scss" scoped>
@use '../../assets/scss/variables' as *;

.facebook-icon path {
  transition: fill $animation-speed-medium ease-out;
}

.facebook-icon:hover path {
  fill: var(--theme-link-hover);
}

.facebook-icon:active path {
  fill: var(--theme-link-active);
}
</style>